import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { MyLog } from '@common/common';
import { DataService } from '@data/data.service';
import { NotificationService } from '@notification/notification.service';
import { isFunction, isJsObject, isNonEmptyString } from '@util/utils';
import SignaturePad from '../../../sigpad/signature_pad';
import { DocumentViewBase } from '../../document-view-base';
import { orderDocumentBase } from '../../order-basic';
import { updateCanvasSize } from '../../../image-edit/image-edit-util';

@Component({
  selector: 'app-edit-document',
  templateUrl: './edit-document.component.html'
})
export class EditDocumentComponent extends DocumentViewBase implements OnInit {

  isImageDoc = false;
  isVideo = false;
  isPdf = false;
  isLoading = false;

  imgUrl: any;

  saveUrl = '';

  signaturePad: SignaturePad | null = null;

  sigEnabled = true;

  actionType = 1;

  data: any;

  private _signatureCanvas?: ElementRef;

  @ViewChild('signCanvas') set signPad(elem: ElementRef) {
    this._signatureCanvas = elem;
    this.signaturePad = updateCanvasSize(elem);
    this.sigEnabled = !!this.signaturePad;
    this.adaptToActionType();
  }

  constructor(public dialogRef: MatDialogRef<EditDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dataService: DataService,
    notificationService: NotificationService
  ) {
    super(notificationService);

    this.saveUrl = orderDocumentBase(dialogData.orderId) + '/' +
      dialogData.docId + '/sign';
  }

  setDocumentInfoFromJsonText(text: any) {
    try {
      const result = JSON.parse(text);
      this.setDocumentInfo(result);
    } catch (e) {
      console.error('Failed to parse file');
    }
  }

  ngOnInit(): void {

    this.data = this.dialogData.content;

    if (isJsObject(this.data)) {
      if (this.data.isvideo) {
        MyLog.log('IS VIDEO');
      }

      if (this.data.isimage) {
        this.imgUrl = this.data.url;
        MyLog.log('IS IMAGE');
      }

      this.isVideo = !!this.data.isvideo;
      this.isImageDoc = !!this.data.isimage;

      this.isPdf = this.data.ispdf;
    }

    if (this.isPdf || this.isImageDoc) {
      this.isLoading = true;
      const editUrl = this.data.url + '/edit';

      this.dataService.get(editUrl).subscribe((res: any) => {
        this.isLoading = false;
        this.setDocumentInfo(res);
      }, (error: any) => {
        this.isLoading = false;
      });
    }
  }

  storeCurrentCanvasData() {
    if (this.currentPage) {
      const p = this.signaturePad;
      if (p) {
        const canvasData = p.toDataURL(); // save image as PNG

        this.canvasPages[this.currentPageIdx] = {
          page: this.currentPageIdx,
          width: this.currentPage.width,
          height: this.currentPage.height,
          unit: this.currentPage.unit,
          data: canvasData
        };
        MyLog.log('Stored', this.canvasPages[this.currentPageIdx]);
      }
    }
  }

  loadCanvasData(pageIndex: number) {
    const canvasData = this.canvasPages[pageIndex];
    const sigPad = this.signaturePad;
    if (sigPad) {
      if (canvasData && canvasData.data) {
        sigPad.fromDataURL(canvasData.data);
      } else {
        sigPad.clear();
      }
    }
  }

  beforeLoadPage(pageIdx:number) {
    this.imgUrl = null;
  }

  storeBeforeLoadPage(pageIdx:number) {
    this.storeCurrentCanvasData();
  }

  loadPageSetData(pageIndex: number) {
    if (this.currentPage.data) {
      this.imgUrl = 'data:image/png;base64,' + this.currentPage.data;
    }
    if (isNonEmptyString(this.currentPage?.url)) {
      this.imgUrl = this.currentPage.url;
    }

    setTimeout(() => {
      if (this._signatureCanvas) {
        this.signaturePad = updateCanvasSize(this._signatureCanvas);
        this.loadCanvasData(pageIndex);
      }
    }, 500);
  }

  clearAll() {
    for (let d of this.canvasPages) {
      if (d) {
        d.data = '';
      }
    }
    const sigPad = this.signaturePad;
    sigPad && sigPad.clear();
  }

  clear(pageNumber: number) {

  }

  signClose(save: boolean) {
    if (save) {
      this.storeCurrentCanvasData();

      /*
      TODO: Validierung.
      if (p.isEmpty()) {
        this.notificationService.showErrors([
          'Sie habe keine Unterschrift gesetzt',
        ]);
        return;
      }
      */
      const reqData: any = {
        pages: this.canvasPages.filter((item: any) => {
          return isJsObject(item) && item.page >= 0 && item.data;
        })
      };
      //MyLog.log('REQ:', this.saveUrl, reqData);

      this.dataService.post(this.saveUrl, reqData, {}).subscribe((res: any) => {
        const data = res?.result;
        if (data.success) {
          this.notificationService.showSuccess('Daten gespeichert');
          this.dialogRef.close(data);
        } else {
          this.notificationService.showErrors([data.error]);
        }

      });
    } else {
      this.dialogRef.close(null);
    }
  }

  eventNames: string[] = [
    'pointerdown',
    'pointermove',
    'pointerup',
    'mousedown',
    'mouseup',
    'mousemove',
    'touchstart',
    'touchmove',
    'touchend'
  ];

  @ViewChild('scrollOverlay', {
    read: ElementRef
  }) set scrollOverlay(elem: ElementRef) {
    if (elem && elem.nativeElement) {
      const e = elem.nativeElement;

      const noAction = ($event: Event) => {
        if ($event && isFunction($event.stopPropagation)) {
          //$event.stopPropagation();
        }
      }

      for (let n of this.eventNames) {
        e.addEventListener(n, noAction, true);
      }

    }
  }

  onActionChange($event: MatRadioChange) {
    this.actionType = $event.value;
    this.adaptToActionType();
  }

  adaptToActionType() {
    const sigPad = this.signaturePad;

    //console.log('Adapt:', this.actionType);
    if (!sigPad) {
      return;
    }

    if (this.actionType !== 2) {
      //this.storeCurrentCanvasData();
      sigPad.off();
      this.sigEnabled = false;
    } else {
      if (!this.sigEnabled) {
        sigPad.on()
        this.sigEnabled = true;
      };
    }
  }
}
